// jQueryFree
// Zde selectbox tom-select, globální inicializace, konfigurujeme přes data atributy
// Pokud nám něco chybí, přídáme data atribut nebo uděláme novou konfiguraci
// Konfigurace pro specifické potřeby je ve vlastních JS např. vyhledávání profesí, oborů, lokalit

// Pro základní inicializaci stačí přidat data-selectbox na select prvek
// Další konfigurace:
// data-checkbox-options - přidá checkboxy pro výběr
// data-remove-button - přidá tlačítko s křížkem pro zrušení výběru
// data-selected-items - neukazuje všechny vybrané položky, ale jen Vybráno (x)

import TomSelect from 'tom-select/dist/js/tom-select.base';
import remove_button from 'tom-select/dist/js/plugins/remove_button';
import checkbox_options from 'tom-select/dist/js/plugins/checkbox_options';
import no_active_items from 'tom-select/dist/js/plugins/no_active_items';

TomSelect.define('remove_button', remove_button);
TomSelect.define('checkbox_options', checkbox_options);
TomSelect.define('no_active_items', no_active_items);

// Plugin pro zobrazení "Vybráno (x)", místo toho, aby se v selectboxu zobrazovaly přímo vybrané položky
// Předáním stringu v data-selected-items se zobrazí místo "Vyberte"
// Nastavením parametru data-selected-items-empty-value docílíme toho, že např. option "Nevybráno" nebo "Nezáleží",
// nepočítáme jako vybrané položky, takže při vybrání  takové option se nezobrazí Vybráno (1)
var plugin_n_items = function () {
	const self = this;
	let div;

	const itemCount = function () {
		let itemsWithValue = self.items.filter((value) => self.input.dataset.selectedItemsEmptyValue !== value);
		if (itemsWithValue.length >= 1) {
			let label = self.input.dataset.selectedItems ? self.input.dataset.selectedItems : 'Vybráno';
			div.innerText = `${label} (${itemsWithValue.length})`;
		} else {
			div.innerText = self.settings.placeholder;
		}
	};

	self.on('initialize', () => {
		div = document.createElement('div');

		self.control.append(div);
		itemCount();
	});

	self.on('item_remove', itemCount);
	self.on('item_add', itemCount);
};

TomSelect.define('n_items', plugin_n_items);

const getTypeFromItem = function (item) {
	if (item.type !== undefined) {
		return item.type;
	} else if (item.$option.dataset.type !== undefined) {
		return item.$option.dataset.type;
	}
	return false;
};

const getRadiusFromItem = function (item) {
	let radius = false;
	if (item.dr !== undefined) {
		radius = parseInt(item.dr);
	} else if (item.$option && item.$option.dataset.dr !== undefined) {
		radius = parseInt(item.$option.dataset.dr);
	}
	return radius;
};

function getHtmlOptions(selectElem) {
	let opts = [];
	selectElem.querySelectorAll('option').forEach((opt) => {
		opts.push({
			id: opt.value,
			text: opt.text,
			dr: opt.dataset.dr,
			type: opt.dataset.type
		});
	});
	return opts;
}

const initSelect = function (element) {
	element.querySelectorAll('[data-selectbox]').forEach((selectEl) => {
		const pluginsList = {};
		if (typeof selectEl.dataset.removeButton !== 'undefined') {
			pluginsList.remove_button = {};
		}

		if (typeof selectEl.dataset.checkboxOptions !== 'undefined') {
			pluginsList.checkbox_options = {
				checkedClassNames: ['ts-checked'],
				uncheckedClassNames: ['ts-unchecked']
			};
		}

		if (typeof selectEl.dataset.noActiveItems !== 'undefined') {
			pluginsList.no_active_items = {};
		}

		const settings = {
			render: {
				no_results: function (data, escape) {
					return '<div class="no-results">Nenalezeny žádné položky</div>';
				}
			},
			hidePlaceholder: true,
			// pro checkbox options nesmíme nastavit closeAfterSelect na true, jinak nedochází k označení checkboxů
			closeAfterSelect: typeof selectEl.dataset.checkboxOptions === 'undefined',
			maxOptions: typeof selectEl.dataset.maxOptions !== 'undefined' ? typeof selectEl.dataset.maxOptions : 100,
			allowEmptyOption: true,
			onInitialize: function () {
				selectEl.classList.remove('tomselect-hidden');
			}
		};

		if (typeof selectEl.dataset.selectedItems !== 'undefined') {
			// plugin pro zobrazení "Vybráno (X)"
			pluginsList.n_items = {};
			settings.controlInput = null;
			settings.render.item = function (data, escape) {
				return '<span></span>';
			};
		}

		if (typeof selectEl.dataset.disableControlInput !== 'undefined') {
			// Vypne input pro našeptávač
			settings.controlInput = null;
		}

		settings.plugins = pluginsList;

		const tomselect = new TomSelect(selectEl, settings);

		// Pokud někde nastavíme hodnotu selecboxu, tak je potřeba tom-select synchronizovat
		selectEl.addEventListener('change', function (e) {
			tomselect.sync();
		});
	});

	// JS pro selectbox vyhledávání lokality, které má své specifické chování a nejde použít globální konfiguraci tom-select
	// Nastavením data-selectbox-locations-with-distance je možné zapnout výběr vzdáleností - využívá se pro vyhledávání inzeártů
	element.querySelectorAll('[data-selectbox-locations]').forEach((selectEl) => {
		let htmlOptions = getHtmlOptions(selectEl);
		const settings = {
			plugins: {
				remove_button: {},
				no_active_items: {}
			},
			hidePlaceholder: true,
			hideSelected: true,
			maxOptions: 100,
			preload: 'focus',
			valueField: 'id',
			labelField: 'text',
			options: htmlOptions, // options z html předávám sem, aby byly zobrazeny na začátku, pokud to tak nebylo, tak se po ajax callbacku míchaly položky v "náhodném pořadí"
			closeAfterSelect: true,
			refreshThrottle: 0,
			loadThrottle: 0,
			load: function (query, callback) {
				fetch(selectEl.dataset.url.replace(selectEl.dataset.urlPlaceholder, encodeURIComponent(query)))
					.then((response) => response.json())
					.then((json) => {
						callback(json.results);
					})
					.catch(() => {
						callback();
					});
			},

			render: {
				item: function (data, escape) {
					const el = document.createElement('div');
					el.innerText = data.text;

					let type = getTypeFromItem(data);
					if (
						['city', 'city_part'].includes(type) &&
						typeof selectEl.dataset.selectboxLocationsWithDistance !== 'undefined'
					) {
						let locationSelectedDistance = getRadiusFromItem(data) ?? 50;
						const radiusSelect = document.createElement('select');
						radiusSelect.setAttribute('name', 'ld[' + data.id + ']');

						[0, 10, 20, 30, 40, 50].forEach((r) => {
							const optionEl = document.createElement('option');
							optionEl.value = r;
							optionEl.innerText = '+ ' + r + 'km';

							if (locationSelectedDistance === r) {
								optionEl.selected = true;
							}

							radiusSelect.appendChild(optionEl);
						});

						// Zabráníme Tom Selectu převzít focus/click z selectu
						['mousedown', 'click', 'focus'].forEach((evt) => {
							radiusSelect.addEventListener(evt, function (e) {
								e.stopPropagation();
							});
						});

						el.appendChild(radiusSelect);
					}

					return el;
				},
				option: function (data, escape) {
					if (data.is_parent) {
						return '<div><strong>' + data.text + '</strong></div>';
					}

					return '<div class="ps-4">' + data.text + '</div>';
				},
				no_results: function (data, escape) {
					return '<div class="no-results">Nenalezeny žádné položky</div>';
				}
			}
		};

		let locationsSelect = new TomSelect(selectEl, settings);

		// Vybrání aktivní položky z ts-dropdown po stisknutí tab
		locationsSelect.control_input.addEventListener('keydown', (e) => {
			if (e.key === 'Tab' && locationsSelect.isOpen) {
				const active = locationsSelect.dropdown.querySelector('.active');
				if (active) {
					e.preventDefault(); // zamezí přeskoku fokusu
					let value = active.dataset.value;
					if (!locationsSelect.items.includes(value)) {
						locationsSelect.addItem(value);
					}
					locationsSelect.close();
				}
			}
		});

		// Otevření dropdownu po kliknutí na položku v ts-control
		locationsSelect.wrapper.addEventListener('mousedown', (e) => {
			if (e.target.classList.contains('item')) {
				e.preventDefault(); // zabrání odfokusu
				locationsSelect.open();
			}
		});
	});

	// JS pro selectbox vyhledávání oborů/profesí, které má své specifické chování a nejde použít globální konfiguraci tom-select
	// Nastavením data-allow-create-item="hledaný výraz" je možné zapnout vytváření položek a nastavení prefixu
	// - využívá se pro vyhledávání podle klíčových slov
	element.querySelectorAll('[data-selectbox-subjects]').forEach((selectEl) => {
		let htmlOptions = getHtmlOptions(selectEl);

		const settings = {
			plugins: {
				remove_button: {},
				no_active_items: {}
			},
			hidePlaceholder: true,
			hideSelected: true,
			maxOptions: 100,
			preload: 'focus',
			valueField: 'id',
			labelField: 'text',
			options: htmlOptions, // options z html předávám sem, aby byly zobrazeny na začátku, pokud to tak nebylo, tak se po ajax callbacku míchaly položky v "náhodném pořadí"
			closeAfterSelect: true,
			create: typeof selectEl.dataset.allowCreateItem !== 'undefined', // možnost vytvoření nové položky - použijeme pro "hledaný výraz"
			// createOnBlur: true, // Pokud odejdu z pole a mám něco napsáno v inputu, tak se vloží nová položka
			createFilter: function (input) {
				return input.length >= 3; // minimum 3 znaky
			},
			load: function (query, callback) {
				fetch(selectEl.dataset.url.replace(selectEl.dataset.urlPlaceholder, encodeURIComponent(query)))
					.then((response) => response.json())
					.then((json) => {
						callback(json.results);
					})
					.catch(() => {
						callback();
					});
			},

			render: {
				option: function (data, escape) {
					const el = document.createElement('div');

					if (!isNaN(data.id)) {
						el.innerText = 'obor: ';
					} else if (data.id !== undefined) {
						if (data.id !== data.text) {
							if (data.id.lastIndexOf('p', 0) === 0) {
								el.innerText = 'profese: ';
							} else if (data.id.lastIndexOf('c', 0) === 0) {
								el.innerText = 'firma: ';
							} else if (data.id.lastIndexOf('a', 0) === 0) {
								el.innerText = 'agentura: ';
							}
						}
					} else {
						el.innerText =
							typeof selectEl.dataset.allowCreateItem !== 'undefined'
								? selectEl.dataset.allowCreateItem + ': '
								: '';
					}

					const text = document.createElement('strong');
					text.innerText = '"' + data.text + '"';

					el.appendChild(text);

					return el;
				},

				option_create: function (data, escape) {
					return (
						'<div class="create">' +
						(typeof selectEl.dataset.allowCreateItem !== 'undefined'
							? selectEl.dataset.allowCreateItem + ': '
							: '') +
						'<strong> "' +
						escape(data.input) +
						'"</strong>&hellip;</div>'
					);
				},
				no_results: function (data, escape) {
					return '<div class="no-results">Nenalezeny žádné položky</div>';
				}
			}
		};

		let subjectSelect = new TomSelect(selectEl, settings);

		// Vybrání aktivní položky z ts-dropdown po stisknutí tab
		subjectSelect.control_input.addEventListener('keydown', (e) => {
			if (e.key === 'Tab' && subjectSelect.isOpen) {
				const active = subjectSelect.dropdown.querySelector('.active');
				if (active) {
					e.preventDefault(); // zamezí přeskoku fokusu
					let value = active.dataset.value;
					if (!subjectSelect.items.includes(value)) {
						subjectSelect.addItem(value);
					}
					subjectSelect.close();
				}
			}
		});

		// Otevření dropdownu po kliknutí na položku v ts-control
		subjectSelect.wrapper.addEventListener('mousedown', (e) => {
			if (e.target.classList.contains('item')) {
				e.preventDefault(); // zabrání odfokusu
				subjectSelect.open();
			}
		});
	});
};

export default function () {
	initSelect(document); // startujeme mimo init, protože pak dochází k většímu zpoždění

	$.nette.ext('tomselect', {
		init: function () {
			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initSelect($el.get(0));
				}
			});
		}
	});
}
